// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3i659","icon":"SortAdornment_icon__311TW","up":"SortAdornment_up__6kBS5","down":"SortAdornment_down__35JBt","active":"SortAdornment_active__1SYJm"};